<template>
  <div class="loginContent">
     <div class="login">
      <el-tabs v-model="loginType" @tab-click="selectLoginType">
          <el-tab-pane label="密码登录" name="0">           
            <div class="loginUserName"><input type="text" placeholder="请输入用户名" v-model="form.name"></div>
            <div class="loginPassword"><input type="password" placeholder="请输入密码" v-model="form.password" @keyup.enter="submitForm"></div>
            <div class="loginCode"><input type="text" placeholder="请输入验证码" v-model="form.code" @keyup.enter="submitForm"><img :src="codeUrl"><div @click="refreshCaptcha">刷新</div></div>
            <div class="loginRemember">      
                <img @click="remember(true)" v-if="!form.isRemember" src="http://img.static.knnnj.com/Default/1b2fbf0b-a909-4d8a-932c-f66bb1850500-2.png">
                <img @click="remember(false)" v-else src="http://img.static.knnnj.com/Default/49625030-cb0b-4ca2-a757-fbef9598096e-2.png">
                <div class="rememberPassword">记住密码</div>    
                <div class="forgetPassword" @click="forget">忘记密码？</div>  
            </div>            
          </el-tab-pane>
          <el-tab-pane label="短信登录" name="1">           
            <div class="loginMobile"><input type="text" placeholder="请输入手机号码" v-model="form.mobile"></div>
            <div class="loginCode"><input type="text" placeholder="请输入验证码" v-model="form.code" @keyup.enter="submitForm"><img :src="codeUrl"><div @click="refreshCaptcha">刷新</div></div>
            <div class="loginShortMsgCode">
              <input class="shortMsgCode" type="text" placeholder="请输入短信验证码" v-model.trim="form.shortMsgCode" @keyup.enter="submitForm">     
              <div class="sendbtn" v-if="!isSendMsg" @click="toSendMsg"> {{shortMsgCodeContent}}</div>   
              <div class="sendbtn1" v-else> {{shortMsgCodeContent}}({{countDown}})</div>   
            </div>           
          </el-tab-pane>
          <el-tab-pane label="微信登录" name="2" >   
            <div class="weixinLogin">
              <div ref="qrcodeContainer"></div>             
            </div>
            <div class="weixinLoginMemo">请用微信扫描二维码登录系统</div>
          </el-tab-pane>
        </el-tabs>     
        <div class="loginBtn" v-if="loginType!='2'">
          <input type="button" value="登录" @click="submitForm">
        </div>
        <div v-if="loginType!='2'" class="loginRegister">没有账号？<span @click="toRegister">立即注册</span></div> 
     </div>
     <forgetPassword ref="forgetPassword" @fetch-data="refreshCaptcha"></forgetPassword>
     <bindingUser ref="bindingUser" @bindingLogin="bindingLogin"></bindingUser>
  </div>
</template>

<style>
@import '../../styles/login.css';
</style>
<script>
import { getCaptchaImage, login, getLoginQRCode, getLoginStatus } from '@/api/login'
import api from '@/api'
import QRCode from 'qrcodejs2' 
import c from '@/common/js'
import { mapMutations, mapActions } from 'vuex'
import ForgetPassword from './components/ForgetPassword'
import BindingUser from './components/BindingUser'
import YButton from '@/components/yButton'
export default {
  name: 'userLogin',
   components: { YButton, ForgetPassword, BindingUser},
  data() {
    return {     
      codeUrl:null,
      qrcode:'',
      form: {
        name: '',
        password: '',
        code: '',
        isRemember: false,
        uniqueCode:'',
        mobile:'',
        shortMsgCode:'',
      },
      shortMsgCodeContent:'获取验证码',
      isSendMsg:false,
      countDown:0,
      loginType:'0',
      isLoading: false,
      timeout: false,              
      time:'',
      guid:''
    }
  },
  created() {
    c.logged()
    this.getlocalStorage()
    this.refreshCaptcha()
    // this.getLoginCode()
  },
  methods: {
    selectLoginType()
    {
      if((this.loginType==2||this.loginType=='2')&&!this.guid)
      {
        this.getLoginCode()
      }
    },
    toSendMsg()
    {
      if (!this.form.mobile) {    
        this.$message.error('手机号码不能为空!')
        return
      }  
      var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
      if(!myreg.test(this.form.mobile))
      {
        this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
        return;
      }       
      if (!this.form.code) {    
        this.$message.error('图形验证码不可为空!')
        return
      }  
      if(this.isSendMsg)return;
      var _this=this;
      api.post('/api/TokenAuth/SendMsg', { mobile:this.form.mobile, code:this.form.code, uniqueCode:this.form.uniqueCode, isLogin:true }).then(response => {
        debugger
          if(response.data.success)
          {
            _this.isSendMsg=true;     
            _this.shortMsgCodeContent = '重新获取';  
            _this.countDown = 60;
            _this.countDownFun();
          }
          else
          {
            _this.$message({  message: response.data.error.message,type: 'error', customClass: 'c-msg',duration: 0, showClose: true })
          }
      }).catch(error => {     
        debugger;
        const { response, message } = error
        var msg = '抱歉，服务器开了个小差!';
        _this.$message({  message: msg,type: 'error', customClass: 'c-msg',duration: 0, showClose: true })
      })
      
    },
    countDownFun()
      {      
        if(this.countDown>0)
        {
           this.countDown--;          
           var _this=this;          
           setTimeout(() => {
              _this.countDownFun()
            }, 1000)
        }
        else 
        {
           this.isSendMsg=false;     
           this.shortMsgCodeContent = '获取验证码';
           return;
        }   
      }, 
    remember(val)
    {
      this.form.isRemember=val;
    },
    toRegister () {
      this.$router.push({ name: 'userRegister' })
    },
    // 跳转到忘记密码页面
    forget() {
      this.$refs['forgetPassword'].showEdit()
    },
    // 登录返回按钮
    login_back () {
      this.$router.go(-1)
    },
    refreshCaptcha()
    {    
      getCaptchaImage().then(response => {
          this.codeUrl ="data:image/jpg;base64," + response.data.result.image;
          this.form.uniqueCode = response.data.result.guid;
      }).catch(error => {     
        this.$message({
          message: '抱歉，服务器开了个小差！',
          type: 'error',
          customClass: 'c-msg',
          duration: 0,
          showClose: true
        })
        Promise.reject(error)
      })
    },
    showQRCode(url){  
          this.qrcode = new QRCode(this.$refs.qrcodeContainer, {
            text: url,  
            width: 168,  
            height: 160,  
            colorDark: '#000000',  
            colorLight: '#ffffff',  
            correctLevel: QRCode.CorrectLevel.H  
          })
    },
    getLoginCode(){    
      var _this=this;
      getLoginQRCode().then(res => {        
           if(res.data&&res.data.success){
              this.guid = res.data.result.guId;
              this.showQRCode(res.data.result.loginUrl)  
              _this.timeout=false;
              this.time = window.setInterval(function () {
                _this.getWXLoginStatus()
                }, 1000)           
           }
        })
      },
      getWXLoginStatus(){
        let guid = this.guid
        var _this = this;
        if(!this.timeout){
          getLoginStatus({ guid : guid }).then(res => {          
            if(res.data&&res.data.success){           
               switch(res.data.result.authStatus)
               {
                 case 2: //未绑定用户
                  _this.time='';
                  _this.timeout=true;
                  _this.$refs['bindingUser'].showEdit(res.data.result)
                  break;
                case 1: //扫码登录成功
                  _this.successLogin(res.data.result.accessToken)
                  break;
               }
            }
          })
        }        
      },
      bindingLogin(row)
      {
        debugger;
         if(row && row.isSuccess)
         {
            this.successLogin(row.accessToken)
         }
      },
    // 验证表单
    submitForm() {
      var loginType = parseInt(this.loginType);
      if(loginType==1)
      {
        if(this.form.mobile==""||this.form.mobile==null||this.form.mobile==undefined)
        {
           this.$message({message:"请输入手机号码", type: 'error', customClass: 'c-msg', showClose: true })     
           return
        }
        var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
        if(!myreg.test(this.form.mobile))
        {
          this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
          return;
        }       
        if(this.form.shortMsgCode==""||this.form.shortMsgCode==null||this.form.shortMsgCode==undefined)
        {
          this.$message({ message: '短信验证码不可为空', type: 'error', customClass: 'c-msg' })
          return;
        }
      }
      else
      {
        if(this.form.name=="")
        {
          return this.$message({message:"请输入用户名", type: 'error', customClass: 'c-msg', showClose: true })     
        }
        if(this.form.password=="")
        {
          return this.$message({message:"请输入密码", type: 'error', customClass: 'c-msg', showClose: true })     
        }
        if(this.form.code=="")
        {
          return this.$message({message:"请输入验证码", type: 'error', customClass: 'c-msg', showClose: true })     
        }
      }
      this.TOGGLE_LOADING_STATUS()
      let data = {
        'password': this.form.password,
        'rememberClient': this.form.isRemember
      }
      // 判断用户是用 name 或 手机 登录的
     
      data.userNameOrEmailAddress = this.form.name
      data.code = this.form.code;
      data.uniqueCode = this.form.uniqueCode;
      if(loginType==1)
      {
         data  =  { 
          userNameOrEmailAddress :this.form.mobile,
          shortMsgCode : this.form.shortMsgCode,
          loginType: 1,
          password: '123'
         }
      }
      
      login(data).then(response => {
        this.TOGGLE_LOADING_STATUS()
        if (response.data.error) {
          return this.$message({
            message: response.data.error.message,
            type: 'error',
            customClass: 'c-msg',
            showClose: true
          })
        }
         if(this.form.isRemember){
            let name = data.userNameOrEmailAddress
            let password = data.password
            this.setLocalStorage(name, password)
          }else{
            this.setLocalStorage('', '')
          }
        this.successLogin(response.data.result.accessToken)
      }).catch(error => {
        this.TOGGLE_LOADING_STATUS()
        this.$message({
          message: '抱歉，服务器开了个小差！',
          type: 'error',
          customClass: 'c-msg',
          duration: 0,
          showClose: true
        })
        Promise.reject(error)
      })
       
    },
    getlocalStorage() {
      if(localStorage.getItem('USER_NAME')){
        this.form.name = localStorage.getItem('USER_NAME')
        this.form.password = localStorage.getItem('PASSWORD')
        this.form.isRemember = true
      }
      
    },
    setLocalStorage(name,password){
      window.localStorage.setItem('USER_NAME', name)
      window.localStorage.setItem('PASSWORD', password)
    },
    // 成功登录后的操作
    successLogin(token) {
      // 存储 ACCESS_TOKEN 进 localstorage
      console.log(token)
      window.localStorage.setItem('ACCESS_TOKEN', token)
      // 更改登录状态
      this.CHECKOUT_LOGIN_STATUS()
      // 加载个人信息
      // this.loadProfile()
      // 跳转到首页
      this.$router.replace('/')
    },
    ...mapMutations([
      'TOGGLE_LOADING_STATUS',
      'CHECKOUT_LOGIN_STATUS'
    ]),
    ...mapActions([
      'loadProfile'
    ])
  }
}
</script>


// WEBPACK FOOTER //
// Login.vue?6146552f